/* ==========================================================
   AIRSTIK® Promotions — Landing Page JavaScript
   ========================================================== */

(function () {
  'use strict';

  /* --------------------------------------------------------
     Intersection-observer entrance animations
  -------------------------------------------------------- */
  function initAnimations() {
    var els = document.querySelectorAll('.ap-animate');
    if (!els.length) return;

    if (!window.IntersectionObserver) {
      // Fallback: show all immediately
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -32px 0px' });

    els.forEach(function (el) { observer.observe(el); });
  }

  /* --------------------------------------------------------
     Smooth anchor scrolling
  -------------------------------------------------------- */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var id = this.getAttribute('href').slice(1);
        if (!id) return;
        var target = document.getElementById(id);
        if (!target) return;
        e.preventDefault();
        var offset = 24;
        var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });
  }

  /* --------------------------------------------------------
     Contact form — prep body field before Shopify submission
     Shopify's {% form 'contact' %} handles the actual POST.
     We just combine "company" and "details" into contact[body].
  -------------------------------------------------------- */
  function initContactForm() {
    var form = document.getElementById('ap-contact-form');
    if (!form) return;

    form.addEventListener('submit', function () {
      var companyInput  = form.querySelector('#ap-field-company');
      var detailsInput  = form.querySelector('#ap-field-details');
      var bodyTarget    = form.querySelector('#ap-field-body');

      if (!bodyTarget) return;

      var company = companyInput ? companyInput.value.trim() : '';
      var details = detailsInput ? detailsInput.value.trim() : '';

      var combined = '';
      if (company) combined += 'Company / School: ' + company + '\n\n';
      if (details) combined += 'Project Details:\n' + details;

      bodyTarget.value = combined.trim();
    });
  }

  /* --------------------------------------------------------
     Sticky CTA — hide when contact form is in view
  -------------------------------------------------------- */
  function initStickyVisibility() {
    var sticky  = document.querySelector('.ap-sticky');
    var form    = document.querySelector('.ap-form-panel');
    if (!sticky || !form) return;

    if (!window.IntersectionObserver) return;

    var observer = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) {
        sticky.classList.add('is-hidden');
      } else {
        sticky.classList.remove('is-hidden');
      }
    }, { threshold: 0.25 });

    observer.observe(form);
  }

  /* --------------------------------------------------------
     Add body class so CSS can add mobile padding
  -------------------------------------------------------- */
  function initBodyClass() {
    var sticky = document.querySelector('.ap-sticky');
    if (sticky) document.body.classList.add('airstik-promo-page');
  }

  /* --------------------------------------------------------
     Initialise
  -------------------------------------------------------- */

  /* --------------------------------------------------------
     Hover-triggered video play with audio
  -------------------------------------------------------- */
  function initVideoAutoplay() {
    var videos = [...document.querySelectorAll('.ap-autovideo')];
    if (!videos.length) return;

    videos.forEach(function(v) {
      var card = v.closest('.ap-video-card') || v.parentElement;

      card.addEventListener('mouseenter', function() {
        // Pause all others first
        videos.forEach(function(other) {
          if (other !== v) { other.pause(); other.currentTime = 0; }
        });
        v.muted = false;
        v.play().catch(function() {
          // Fallback: play muted if browser blocks sound
          v.muted = true;
          v.play().catch(function(){});
        });
      });

      card.addEventListener('mouseleave', function() {
        v.pause();
        v.currentTime = 0;
      });
    });
  }

  function init() {
    initAnimations();
    initSmoothScroll();
    initContactForm();
    initStickyVisibility();
    initBodyClass();
    initVideoAutoplay();
  }

  if (document.readyState === 'loading') {
    



// ── Suction cup letter reveal for customization cards ──
function initSuctionText() {
  document.querySelectorAll('.ap-custom-card').forEach(function(card) {
    var chars = [];
    function walk(node) {
      if (node.nodeType === 3) {
        var text = node.textContent;
        var parent = node.parentNode;
        var frag = document.createDocumentFragment();
        for (var i = 0; i < text.length; i++) {
          if (text[i].trim() === '') {
            frag.appendChild(document.createTextNode(text[i]));
          } else {
            var span = document.createElement('span');
            span.className = 'ap-char';
            span.textContent = text[i];
            chars.push(span);
            frag.appendChild(span);
          }
        }
        parent.replaceChild(frag, node);
      } else if (node.nodeType === 1 && node.tagName !== 'SCRIPT' && node.tagName !== 'STYLE') {
        Array.from(node.childNodes).forEach(walk);
      }
    }
    walk(card);

    function reveal() {
      if (!chars.length) return;
      var shuffled = chars.slice().sort(function() { return Math.random() - 0.5; });
      var total = 3200;
      shuffled.forEach(function(span, i) {
        setTimeout(function() { span.classList.add('is-stuck'); }, (i / shuffled.length) * total);
      });
    }

    var triggered = false;
    var obs = new IntersectionObserver(function(entries) {
      if (entries[0].isIntersecting && !triggered) {
        triggered = true;
        obs.disconnect();
        reveal();
      }
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });
    obs.observe(card);
  });
}

document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();




// ── Selling-pt tap highlight ────────────────────────────
function initSellingPtTap() {
  document.querySelectorAll('.ap-selling-pt').forEach(function(pt) {
    pt.addEventListener('touchstart', function() {
      pt.classList.add('is-tapped');
    }, { passive: true });
    pt.addEventListener('touchend', function() {
      setTimeout(function() { pt.classList.remove('is-tapped'); }, 700);
    }, { passive: true });
  });
}

// ── Mobile slide directions ─────────────────────────────
function initMobileSlides() {
  if (window.innerWidth > 767) return;
  document.querySelectorAll('.ap-feature-card').forEach(function(el, i) {
    el.classList.add(i % 2 === 0 ? 'ap-animate--left' : 'ap-animate--right');
  });
  document.querySelectorAll('.ap-checklist__item').forEach(function(el, i) {
    el.classList.add(i % 2 === 0 ? 'ap-animate--right' : 'ap-animate--left');
  });
  document.querySelectorAll('.ap-selling-pt').forEach(function(el, i) {
    el.classList.add(i % 2 === 0 ? 'ap-animate--left' : 'ap-animate--right');
  });
}

document.addEventListener('DOMContentLoaded', function() {
  initSellingPtTap();
  initMobileSlides();
  initSuctionText();
});
